import Footer from 'components/Footer'
import HeaderLarge from 'components/HeaderLarge'
import { useCampaignStatusPolling } from 'hooks/useCampaignStatusPolling'
import * as React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'

const PROCESSING_MESSAGE = '処理中です（最大15秒）。' as const
const LONG_RUNNING_MESSAGE = '処理に時間がかかっています。もうしばらくお待ちください。' as const
const TIMEOUT_MESSAGE = '処理が遅延しています。しばらくしてから再度ログインしてください。' as const
const COMPLETED_MESSAGE = '仮登録申込が完了しました。ログインしてダッシュボードからご確認ください。' as const
const LOGIN_PATH = '/login' as const

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const { token } = useParams()
  const { status, showLongRunningMessage } = useCampaignStatusPolling(token)

  const handleLoginClick = (): void => {
    navigate(LOGIN_PATH)
  }

  return (
    <>
      <HeaderLarge title="仮登録申込状況" />
      <main className="mx-4 my-5">
        {status === 'processing' && (
          <div className="d-flex flex-column align-items-center mt-5">
            <Spinner animation="border" role="status" />
            <p className="mt-3">{PROCESSING_MESSAGE}</p>
            {showLongRunningMessage && <p className="mt-2 note">{LONG_RUNNING_MESSAGE}</p>}
          </div>
        )}

        {status === 'completed' && (
          <div className="d-flex flex-column align-items-center mt-5">
            <p>{COMPLETED_MESSAGE}</p>
            <Button variant="primary" className="w-100 py-4 mt-4" onClick={handleLoginClick}>
              ログインしてダッシュボードを見る
            </Button>
          </div>
        )}

        {status === 'timeout' && (
          <div className="mt-5">
            <p className="text-danger">{TIMEOUT_MESSAGE}</p>
          </div>
        )}

        {status === 'error' && (
          <div className="mt-5">
            <p className="text-danger">処理中にエラーが発生しました。時間をおいて再度ご確認ください。</p>
          </div>
        )}
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
